/*
 * @Descripttion: 申请开票页面state
 * @Author: 曹博
 * @Date: 2023-11-27 15:02:19
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-27 15:06:41
 */
import { OrderDteailRes, ProductList } from '../../api/orderManage'
import { ActionType, CustomAction } from '../../global'
import { fileFile } from '../../modules/uploadfiles/hooks'

export interface RouteParams {
  orderIds: string[]
}

export interface State {
  uploadFilesList: fileFile[]
  routeParams: RouteParams
  orderData: OrderDteailRes[]
  materialData: ProductList[]
  isPageLoading: boolean
  isSubmitButtonLoading: boolean
  formData: any
}
export const initialState: State = {
  uploadFilesList: [],
  routeParams: {
    orderIds: [],
  },
  orderData: [],
  materialData: [],
  isPageLoading: false,
  isSubmitButtonLoading: false,
  formData: {},
}

type Action = ActionType<State>

export default function reducer(
  state: State = initialState,
  action: CustomAction<Action>,
): State {
  let newstate = { ...state }
  switch (action.type) {
    case 'reloadStateAction':
      newstate = action.payload
      return newstate
    case 'setUploadFilesListAction':
      newstate.uploadFilesList = action.payload
      return newstate
    case 'setRouteParamsAction':
      newstate.routeParams = action.payload
      return newstate
    case 'setOrderDataAction':
      newstate.orderData = action.payload
      return newstate
    case 'setMaterialDataAction':
      newstate.materialData = action.payload
      return newstate
    case 'setIsPageLoadingAction':
      newstate.isPageLoading = action.payload
      return newstate
    case 'setIsSubmitButtonLoadingAction':
      newstate.isSubmitButtonLoading = action.payload
      return newstate
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

export const reloadStateAction = (val: State): CustomAction<Action> => ({
  type: 'reloadStateAction',
  payload: val,
})

export const setUploadFilesListAction = (
  val: fileFile[],
): CustomAction<Action> => ({
  type: 'setUploadFilesListAction',
  payload: val,
})

export const setRouteParamsAction = (
  val: RouteParams,
): CustomAction<Action> => ({
  type: 'setRouteParamsAction',
  payload: val,
})

export const setOrderDataAction = (
  val: OrderDteailRes[],
): CustomAction<Action> => ({
  type: 'setOrderDataAction',
  payload: val,
})

export const setMaterialDataAction = (
  val: ProductList[],
): CustomAction<Action> => ({
  type: 'setMaterialDataAction',
  payload: val,
})

export const setIsPageLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setIsPageLoadingAction',
  payload: val,
})

export const setIsSubmitButtonLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsSubmitButtonLoadingAction',
  payload: val,
})

/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): CustomAction<Action> => ({
  type: 'setFormDataAction',
  payload: val,
})
/*
 * @Descripttion: 申请开票页面state
 * @Author: 曹博
 * @Date: 2023-11-27 15:02:19
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-27 15:06:41
 */
import { OrderDteailRes, ProductList } from '../../api/orderManage'
import { ActionType, CustomAction } from '../../global'
import { fileFile } from '../../modules/uploadfiles/hooks'

export interface RouteParams {
  orderIds: string[]
}

export interface State {
  uploadFilesList: fileFile[]
  routeParams: RouteParams
  orderData: OrderDteailRes[]
  materialData: ProductList[]
  isPageLoading: boolean
  isSubmitButtonLoading: boolean
  formData: any
}
export const initialState: State = {
  uploadFilesList: [],
  routeParams: {
    orderIds: [],
  },
  orderData: [],
  materialData: [],
  isPageLoading: false,
  isSubmitButtonLoading: false,
  formData: {},
}

type Action = ActionType<State>

export default function reducer(
  state: State = initialState,
  action: CustomAction<Action>,
): State {
  let newstate = { ...state }
  switch (action.type) {
    case 'reloadStateAction':
      newstate = action.payload
      return newstate
    case 'setUploadFilesListAction':
      newstate.uploadFilesList = action.payload
      return newstate
    case 'setRouteParamsAction':
      newstate.routeParams = action.payload
      return newstate
    case 'setOrderDataAction':
      newstate.orderData = action.payload
      return newstate
    case 'setMaterialDataAction':
      newstate.materialData = action.payload
      return newstate
    case 'setIsPageLoadingAction':
      newstate.isPageLoading = action.payload
      return newstate
    case 'setIsSubmitButtonLoadingAction':
      newstate.isSubmitButtonLoading = action.payload
      return newstate
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

export const reloadStateAction = (val: State): CustomAction<Action> => ({
  type: 'reloadStateAction',
  payload: val,
})

export const setUploadFilesListAction = (
  val: fileFile[],
): CustomAction<Action> => ({
  type: 'setUploadFilesListAction',
  payload: val,
})

export const setRouteParamsAction = (
  val: RouteParams,
): CustomAction<Action> => ({
  type: 'setRouteParamsAction',
  payload: val,
})

export const setOrderDataAction = (
  val: OrderDteailRes[],
): CustomAction<Action> => ({
  type: 'setOrderDataAction',
  payload: val,
})

export const setMaterialDataAction = (
  val: ProductList[],
): CustomAction<Action> => ({
  type: 'setMaterialDataAction',
  payload: val,
})

export const setIsPageLoadingAction = (val: boolean): CustomAction<Action> => ({
  type: 'setIsPageLoadingAction',
  payload: val,
})

export const setIsSubmitButtonLoadingAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsSubmitButtonLoadingAction',
  payload: val,
})

/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): CustomAction<Action> => ({
  type: 'setFormDataAction',
  payload: val,
})
